var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15.3021C5 19.9268 7.5419 22 11.0894 22C13.3426 22 15.0186 21.2495 16.3594 19.8236C18.2216 17.8443 18.8361 14.8236 19.1899 13.651C19.4786 12.7129 20 11.531 20 10.9024C20 10.4991 19.4693 10.1426 19.1155 10.1426C18.3147 10.1426 18.0074 10.5084 17.5419 11.5216C17.0205 12.6379 16.3873 14.7205 15.8845 14.7205C15.5959 14.7205 15.4935 14.1951 15.4935 13.2195V4.16698C15.4935 3.66979 15.1955 3.21951 14.5624 3.21951C13.9385 3.21951 13.6313 3.66979 13.6313 4.16698V11.5779C13.3333 11.4934 12.9888 11.4184 12.6164 11.3715V2.93809C12.6164 2.4409 12.3091 2 11.6853 2C11.0615 2 10.7542 2.4409 10.7542 2.93809V11.3058C10.4097 11.3246 10.0745 11.3621 9.73929 11.4184V3.66041C9.73929 3.16323 9.42272 2.71295 8.80819 2.71295C8.19367 2.71295 7.87709 3.16323 7.87709 3.66041V11.9437C7.51397 12.0938 7.16946 12.272 6.8622 12.469V6.57786C6.8622 6.08068 6.57356 5.63039 5.94972 5.63039C5.30726 5.63039 5 6.08068 5 6.57786V15.3021Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHand);
export default __webpack_public_path__ + "static/media/icon-hand.04023f9dede9aa3b8dfac9551e16436c.svg";
export { ForwardRef as ReactComponent };